import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import Backend from "i18next-xhr-backend";
import LanguageDetector from "i18next-browser-languagedetector";
const Languages = ["en", "es", "fr", "he", "pt"];
const options = {
    order: ["navigator"]
};
const languageDetector = new LanguageDetector(null, options);

export default i18n
    .use(Backend)
    .use(languageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: ["ca", "gl", "eu"].indexOf(navigator.language) > -1 ? "es" : "en",
        debug: false,
        whitelist: Languages,
        interpolation: {
            escapeValue: false
        },
        backend: {
            loadPath: '/fidelitymonitor/locales/{{lng}}/{{ns}}.json'
        },
        initImmediate: false,
    });